export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_fragment_6.2e2d6cca.jpg";